import { tracker, UserActionType } from '../../../tracking';
import { styled } from 'goober';
import { Container, ImageForSlides } from './slideOne';

const InnerContainer = styled('div')`
  display: flex;
  flex-flow: column;
  margin-left: 80px;
  position: absolute;
  top: 50px;
  @media only screen and (max-width: 600px) {
    margin-left: 40px;
    left: 20px;
    top: 0;
  }
  @media only screen and (max-width: 450px) {
    left: 0;
  }
`;
const HowToUseText = styled('p')`
  display: flex;
  align-items: end;
  width: 211px;
  height: 86px;
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 43px;
  color: #00733b;
  margin-top: 0;
  margin-bottom: 0;
  @media only screen and (max-width: 600px) {
    font-size: 20px;
    line-height: 35px;
  }
`;
const ClickHereButton = styled('button')`
  width: 196px;
  height: 50px;
  background: #1abc70;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  @media only screen and (max-width: 600px) {
    width: 150px;
    height: 40px;
  }
`;
const ClickHereText = styled('span')`
  width: 137px;
  height: 34px;
  font-weight: 500;
  font-size: 27px;
  line-height: 34px;
  color: #ffffff;
  @media only screen and (max-width: 600px) {
    font-size: 20px;
    line-height: 25px;
  }
`;
const ImageContainerForSlides = styled('div')`
  margin-top: 4px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 248px;
  height: 270px;
  @media only screen and (min-height: 360px) and (max-width: 600px) {
    width: 40%;
    height: 30vw;
  }
  @media only screen and (min-height: 320px) and (max-width: 359px) {
    width: 32%;
    height: 23vw;
  }
`;

const SlideFive = ({ setShouldShowHtbModal, pageKey }) => {
  const handleClickForEducationalModal = () => {
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      'bic_education_modal_how_to_use',
      pageKey,
    );
    setShouldShowHtbModal(true);
  };

  return (
    <Container>
      <InnerContainer>
        <HowToUseText>How to use?</HowToUseText>
        <ClickHereButton onClick={() => handleClickForEducationalModal()}>
          <ClickHereText>Click Here</ClickHereText>
        </ClickHereButton>
      </InnerContainer>

      <ImageContainerForSlides>
        <ImageForSlides
          style={{
            backgroundImage:
              "url('https://iccdn.in/img/edu_modal_hero_image2.png')",
          }}
        />
      </ImageContainerForSlides>
    </Container>
  );
};
export default SlideFive;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/educationalModal/slideFive.js